// @flow

import { type PendingIncomingPayment } from './types';
import type { BankTransferDetail } from '@tectonics/prs/incoming-payment/bank_transfer_detail';

export function getBankTransferDetail(incomingPayment: PendingIncomingPayment): BankTransferDetail {
  const bank_transfer_detail = incomingPayment.bank_transfer_detail;
  if (!bank_transfer_detail) {
    return {
      bank_account: '',
      bank_destination: '',
      bank_beneficiary: '',
      bank_beneficiary_document_text: '',
      bank_beneficiary_document: '',
      bank_international_code: '',
    };
  }
  return bank_transfer_detail;
}
